import { createFileRoute } from '@tanstack/react-router'
import PaymentSuccess from '#pages/common/payment-success/ui/payment-success'
import { TopAlignedLayout } from '#widgets/layouts/top-aligned-layout'

export const Route = createFileRoute('/payment/success')({
  component: () => (
    <TopAlignedLayout>
      <PaymentSuccess />
    </TopAlignedLayout>
  ),
})
